/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_QualityInputs */

const en_tab_quality = /** @type {(inputs: Tab_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quality`)
};

const es_tab_quality = /** @type {(inputs: Tab_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calidad`)
};

/**
* | output |
* | --- |
* | "Quality" |
*
* @param {Tab_QualityInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tab_quality = /** @type {((inputs?: Tab_QualityInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_QualityInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tab_quality(inputs)
	return es_tab_quality(inputs)
});